import { LocalStorage } from '../auth/local.storage';
// import { Output, EventEmitter } from '@angular/core';
import { OneDriveAuthInfo } from './one-drive/one-drive.auth.service';
import { CloudServiceEnum } from './enums/cloud-service.enum';
import { DropboxAuthInfo } from './dropbox/dropbox-auth.service';
import { SecurityHelper, StringHelper } from '../../utils/helpers';

export const CLOUD_PKCE_VERIFIER_KEY = 'CLOUD_PKCE_VERIFIER';

export interface IBasePopWinAuth {
  url: string;
  windowName: string;
}

export interface AuthModel extends IBasePopWinAuth {
  localStorageKey: string;
  codeChallenge?: string;
  codeChallengeMethod?: string;
}

const POPUP_SETTINGS = 'dialog=yes,dependent=yes,scrollbars=yes,location=yes';

export class CloudAuthBaseService {
  // @Output() redirectNotification: EventEmitter<void> = new EventEmitter();

  constructor(protected readonly localStorage: LocalStorage) { }

  protected generatePkce(): { verifier: string; challenge: string; method: string } {
    const verifier = StringHelper.toBase64URLEncode(SecurityHelper.getRandomBytes(32).toString('base64'));
    const challenge = StringHelper.toBase64URLEncode(SecurityHelper.sha256(verifier));
    return { verifier, challenge, method: 'S256' };
  }

  public authorizePopup(options: AuthModel, addMessageListener = true): Promise<void> {
    return new Promise((res, rej) => {
      const openedWindow = window.open(options.url, options.windowName, POPUP_SETTINGS);
      const messageListener = (e) => {
        console.log('message from OAUTH popup: ', e, e.data);
        if (window.location.origin !== e.origin || e.data === undefined) {
          // Throw error
          return rej();
        } else {
          const message = e.data as CloudPopupMessage;

          if (message && message.data && (message.cloud === CloudServiceEnum.DropBox || message.cloud === CloudServiceEnum.OneDrive)) {
            if (message.cloud === CloudServiceEnum.DropBox) {
              const authInfo =  message.data as DropboxAuthInfo;
              this.localStorage.setWithExpiry<DropboxAuthInfo>(options.localStorageKey, authInfo, (authInfo?.expires_in ?? 1) * 1000 );
            } else if (message.cloud === CloudServiceEnum.OneDrive) {
              const authInfo =  message.data as OneDriveAuthInfo;
              this.localStorage.setWithExpiry<OneDriveAuthInfo>(options.localStorageKey, authInfo, (authInfo?.expires_in ?? 1) * 1000 );
            }

            // this.redirectNotification.emit();
            window.removeEventListener('message', messageListener);
            return res();
          }
          return rej();
        }
      };

      if (addMessageListener) {
        window.addEventListener('message', messageListener, false);
      }

      // check when not origin pop up window will be closed
      if (openedWindow) {
        let intCheckId = setInterval(() => {
          if (openedWindow.closed) {
            clearInterval(intCheckId);
            return addMessageListener ? rej() : res();
          }
        }, 500);
      }
    })
  }

  public logoutPopup(options: IBasePopWinAuth): Promise<void> {
    return new Promise((res) => {
      const openedWindow = window.open(options.url, options.windowName, POPUP_SETTINGS);
      if (openedWindow) {
        let intCheckId = setInterval(() => {
          if (openedWindow.closed) {
            clearInterval(intCheckId);
            return res();
          }
        }, 500);
      }
    })
  }
}

export interface CloudPopupMessage {
  data: DropboxAuthInfo | OneDriveAuthInfo;
  cloud: CloudServiceEnum;
}
